import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonModal, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { BerService } from '../ber.service';
import { BER_OPCIOK, honapNev } from '../ber.opciok';
import { dokumentumNyomtat } from '../adatszolg/dokumentum-nyomtatas';
import { berjegyzekLap, berjegyzekOpciok, berjegyzekOpciokMent } from '../adatszolg/berjegyzek';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

// BER számfejtés: havi auto-számfejtés a kiválasztott ügyfél jogviszonyaira.
// Előnézet → mentés → véglegesítés; bérlap nyomtatható nézet; jelenlét-rögzítés + .beo import.
@Component({
  selector: 'app-ber-szamfejtes',
  templateUrl: './szamfejtes.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../ber-shared.scss', './szamfejtes.component.scss'],
})
export class SzamfejtesComponent implements OnInit, OnDestroy {
  @ViewChild('jelModal') jelModal: IonModal;
  @ViewChild('egyebModal') egyebModal: IonModal;
  @ViewChild('hokoziModal') hokoziModal: IonModal;
  @ViewChild('koltsegModal') koltsegModal: IonModal;
  @ViewChild('beoFile') beoFile: any;

  elonezet: any[] = [];
  alkalmazottak: any[] = [];
  szamitva = false;
  evek: number[] = [];
  honapok = BER_OPCIOK.honapok;
  honapNev = honapNev;

  jelSzerk: any = null;

  constructor(private ber: BerService, private toast: ToastController, private alert: AlertController, private szerkZar: SzerkZarService,
              private router: Router) {}

  async ngOnInit() {
    await this.ber.init();
    const ev = new Date().getFullYear();
    this.evek = [ev + 1, ev, ev - 1, ev - 2, ev - 3];
    //  Az alkalmazottak és a számolás egyszerre (2026-11-05 – eddig egymás után).
    if (this.aktiv.ugyfelId) {
      await Promise.all([
        this.ber.get('/alkalmazottak/' + this.aktiv.ugyfelId).then((l: any) => { this.alkalmazottak = l; }),
        this.szamol(),
      ]);
    }
  }

  get aktiv() { return this.ber.aktiv; }
  async evValt(ev: number) { await this.ber.setAktiv({ ev }); await this.szamol(); }
  async hoValt(ho: number) { await this.ber.setAktiv({ ho }); await this.szamol(); }

  async szamol() {
    if (!this.aktiv.ugyfelId) return;
    try {
      //  A számolás és a hónap kifizetései egyszerre (egymástól függetlenek).
      const [elonezet] = await Promise.all([
        this.ber.post('/szamfejtes/szamol/' + this.aktiv.ugyfelId + this.ber.evhoq(), {}),
        this.kifizetesekBetolt(),
      ]);
      this.elonezet = elonezet as any;
      this.szamitva = true;
    } catch (e: any) { this.hiba('A számfejtés nem sikerült.'); }
  }

  /*  HÓKÖZI KIFIZETÉS. A hónapban több kifizetés is lehet (előleg, kilépő elszámolása). A kiszolgáló
   *  göngyölítve számol: a hónap elejétől a megadott napig, mínusz a már kifizetettek – így a havi
   *  adó, járulék és a kedvezmény-korlátok akkor is pontosak, ha több részletben fizetünk. */
  hokozi: any = null;
  hokoziFut = false;
  hokoziSorok: any[] = [];
  async kifizetesekBetolt() {
    try {
      const sorok: any[] = await this.ber.get('/szamfejtesek/' + this.aktiv.ugyfelId + this.ber.evhoq());
      // Csak akkor mutatjuk a kifizetés-bontást, ha volt hóközi – egyébként a fenti táblázat elég.
      const hokoziAlk = new Set(sorok.filter((r) => r.tipus === 'hokozi').map((r) => r.alkalmazott_id));
      this.hokoziSorok = hokoziAlk.size ? sorok.filter((r) => hokoziAlk.has(r.alkalmazott_id)) : [];
    } catch { this.hokoziSorok = []; }
  }
  hokoziNyit() {
    const ho = String(this.aktiv.ho).padStart(2, '0');
    this.hokozi = { ig: `${this.aktiv.ev}-${ho}-15`, kifizetes: `${this.aktiv.ev}-${ho}-15`, megnevezes: 'Bérelőleg', jogviszony_id: null };
    this.hokoziModal.present();
  }
  async hokoziMent() {
    this.hokoziFut = true;
    try {
      const r: any = await this.ber.post('/szamfejtes/' + this.aktiv.ugyfelId + '/hokozi' + this.ber.evhoq(), {
        ig: this.hokozi.ig, kifizetes: this.hokozi.kifizetes, megnevezes: this.hokozi.megnevezes,
        jogviszony_idk: this.hokozi.jogviszony_id ? [this.hokozi.jogviszony_id] : null,
      });
      await this.hokoziModal.dismiss();
      await this.szamol();
      this.ok(`${r.mentett} hóközi kifizetés rögzítve${r.ujraszamolt ? `, ${r.ujraszamolt} havi zárás újraszámolva` : ''}.`);
      for (const k of r.kihagyva || []) this.hiba(k);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült rögzíteni.'); }
    finally { this.hokoziFut = false; }
  }
  /*  A havi számfejtés TELJES törlése: a bérlap tételei, és a letiltás e havi levonásai is (a
   *  tartozás visszaáll). Véglegesítettet csak visszanyitás után. */
  async szamfejtesTorol(e: any) {
    const a = await this.alert.create({ header: 'Számfejtés törlése',
      message: `${e.alkalmazott_nev || e.nev || ''} ${this.aktiv.ev}. ${this.aktiv.ho}. havi számfejtése törlődik`
        + (Number(e.letiltas) > 0 ? `, és a letiltásból is eltűnik a hónap ${Number(e.letiltas).toLocaleString('hu-HU')} Ft-os levonása (a tartozás visszaáll).` : '.'),
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => {
        try { await this.ber.del('/szamfejtes/' + e.mentett_id); await this.szamol(); this.ok('A számfejtés törölve.'); }
        catch (x: any) { this.hiba(x?.error?.error || 'Nem sikerült törölni.'); }
      } }] });
    await a.present();
  }
  async hokoziTorol(r: any) {
    const a = await this.alert.create({ header: 'Hóközi kifizetés törlése',
      message: `${r.alkalmazott_nev} – ${r.megnevezes || 'hóközi kifizetés'} (${r.netto} Ft nettó). A hónap zárását utána újra kell számolni.`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => {
        try { await this.ber.del('/szamfejtes/' + r.id); await this.szamol(); this.ok('Törölve – a havi zárás újraszámolva.'); }
        catch { this.hiba('Nem sikerült törölni.'); }
      } }] });
    await a.present();
  }

  /*  Megbízás: ha a mentés szerint valaki a hónapban biztosított lett (vagy a bejelentett már nem az),
   *  szólunk, és a 08E egy gombnyomással megnyitható. A teendő a BÉR főoldalán is megmarad. */
  private async megbizasJelez(r: any) {
    const t: any[] = r?.megbizas_teendok || [];
    if (!t.length) return;
    const uj = t.filter((x) => x.allapot === 'teendo').map((x) => x.nev);
    const torol = t.filter((x) => x.allapot === 'visszavonando').map((x) => x.nev);
    const sorok = [
      uj.length ? `Biztosított lett ebben a hónapban (megbízás, a díj elérte a minimálbér 30%-át): ${uj.join(', ')}. A 08E bejelentést legkésőbb holnap be kell adni.` : '',
      torol.length ? `A bejelentett biztosítás az újraszámfejtés szerint már nem áll fenn: ${torol.join(', ')} – a 08E-n törölni kell.` : '',
    ].filter(Boolean);
    const a = await this.alert.create({ header: '08E – biztosítotti bejelentés', message: sorok.join('\n\n'), cssClass: 'sortores-alert',
      buttons: [{ text: 'Később', role: 'cancel' }, { text: '08E megnyitása', role: 'ok' }] });
    await a.present();
    if ((await a.onDidDismiss()).role === 'ok') {
      this.router.navigate(['/ber/bevallasok'], { queryParams: { kod: 'T1041', ev: this.aktiv.ev, ho: this.aktiv.ho, gyakorisag: 'havi' } });
    }
  }

  osszeg(mezo: string) { return this.elonezet.reduce((s, e) => s + (Number(e[mezo]) || 0), 0); }

  async mentMind() {
    try {
      const r: any = await this.ber.post('/szamfejtes/' + this.aktiv.ugyfelId + this.ber.evhoq(), {});
      await this.szamol();
      this.ok(`${r?.mentett || 0} számfejtés mentve.`);
      await this.megbizasJelez(r);
    } catch (e: any) { this.hiba(e?.error?.error || 'Mentési hiba.'); }
  }

  async mentEgy(e: any) {
    try {
      const r: any = await this.ber.post('/szamfejtes/' + this.aktiv.ugyfelId + this.ber.evhoq(), { jogviszony_idk: [e.jogviszony_id] });
      await this.szamol();
      this.ok('Mentve.');
      await this.megbizasJelez(r);
    } catch { this.hiba('Hiba.'); }
  }

  async veglegesit(e: any) {
    if (!e.mentett_id) { await this.mentEgy(e); await this.szamol(); }
    const id = this.elonezet.find((x) => x.jogviszony_id === e.jogviszony_id)?.mentett_id;
    if (!id) return;
    await this.ber.put('/szamfejtes/' + id + '/veglegesit', {});
    await this.szamol(); this.ok('Véglegesítve.');
  }
  async vissza(e: any) {
    if (!e.mentett_id) return;
    await this.ber.put('/szamfejtes/' + e.mentett_id + '/veglegesit', { vissza: true });
    await this.szamol(); this.ok('Visszaállítva tervezetté.');
  }

  // bérlap (nyomtatás; az asztali programban PDF-előnézettel) – a részletes bérjegyzék (adatszolg/berjegyzek.ts), a Nyomtatványokéval azonos
  /** A bérlap kapcsolható blokkjai (naptár, munkáltatói közterhek) – alapból mind be; a Nyomtatványokkal közös. */
  bjOpciok = berjegyzekOpciok();
  bjOpciokMent() { berjegyzekOpciokMent(this.bjOpciok); }
  async berlap(e: any) {
    const id = e.mentett_id;
    if (!id) { this.hiba('Előbb mentsd el a számfejtést.'); return; }
    const d: any = await this.ber.get('/berlap/' + id);
    const s = d.szamfejtes, a = d.alkalmazott;
    const lap = berjegyzekLap(d, this.bjOpciok);
    dokumentumNyomtat(`Bérlap – ${a?.nev || ''} ${s.ev}. ${honapNev(s.ho)}`, [lap]);
  }

  /*  JELENLÉT egy alkalmazottra (aktív hónap). Két nézet:
   *   - NAPOK: a hónap naptára, a napok státusza ecsettel festhető; a havi összesítő ebből
   *     számolódik (backend/ber-sulinform.js). SULINFORM-hoz kötött alkalmazottnál a napok onnan
   *     jönnek, és mentéskor oda vissza is íródnak.
   *   - ÖSSZESÍTŐ: a havi órák kézzel (régi mód, pl. .beo importnál).
   *  A pótlék-órák (túlóra, éjszakai …) mindkét nézetben kézzel adhatók. */
  jelKep: any = null;
  jelNapok: Record<string, number> = {};
  jelMod: 'napok' | 'osszesito' = 'napok';
  ecset = 1;
  readonly statuszLista = [
    { k: 1, n: 'Dolgozik', r: 'D' }, { k: 2, n: 'Szabadság', r: 'Sz' }, { k: 3, n: 'Beteg', r: 'B' },
    { k: 4, n: 'Kiküldetés', r: 'K' }, { k: 7, n: 'Távmunka', r: 'T' }, { k: 6, n: 'Mentesülés', r: 'M' },
    { k: 5, n: 'Fizetés nélküli', r: 'F' }, { k: 0, n: 'Törlés', r: '' },
  ];
  rovid(st: any): string { return this.statuszLista.find((x) => x.k === Number(st))?.r || ''; }
  statuszNev(st: any): string { return this.statuszLista.find((x) => x.k === Number(st))?.n || 'Nincs adat'; }
  get jelAlk(): any { return this.jelKep?.alkalmazottak?.[0] || null; }

  /*  A naptár hetekre bontva (hétfővel kezdődő sorok, üres cellákkal kiegészítve). TÁROLT érték, nem getter:
   *  a getter minden változásészleléskor új tömböt adott, az *ngFor ezért a teljes naptárat újraépítette – a
   *  modál tartalomfigyelőjével együtt ez végtelen ciklus volt, a jelenlét-ablak lefagyott (2026-11-05). */
  jelHetek: any[][] = [];
  private jelHetekSzamol() {
    const napok: any[] = this.jelKep?.naptar?.napok || [];
    const hetek: any[][] = [];
    if (napok.length) {
      const cellak: any[] = Array((napok[0].hetnap + 6) % 7).fill(null).concat(napok);
      while (cellak.length % 7) cellak.push(null);
      for (let i = 0; i < cellak.length; i += 7) hetek.push(cellak.slice(i, i + 7));
    }
    this.jelHetek = hetek;
  }
  napKattint(n: any) {
    if (this.ecset === 0) delete this.jelNapok[n.datum];
    else this.jelNapok[n.datum] = this.ecset;
  }
  uresMunkanapKitolt() {
    for (const n of this.jelKep?.naptar?.napok || []) if (n.munkanap && !this.jelNapok[n.datum]) this.jelNapok[n.datum] = 1;
  }

  /** Élő összesítő – ugyanaz a szabály, mint a kiszolgálón (ber-sulinform.js osszesit). */
  get jelElonezet() {
    const naptar = this.jelKep?.naptar, a = this.jelAlk;
    if (!naptar || !a) return null;
    let ledolg = 0, szab = 0, beteg = 0, fizNelk = 0, nincs = 0;
    for (const n of naptar.napok) {
      if (!n.munkanap) continue;
      const st = this.jelNapok[n.datum];
      if (!st) { nincs++; ledolg++; }
      else if ([1, 4, 6, 7].includes(st)) ledolg++;
      else if (st === 2) szab++;
      else if (st === 3) beteg++;
      else if (st === 5) fizNelk++;
    }
    const maradt = Math.max(0, (a.keretek?.beteg_keret || 15) - (a.keretek?.beteg_elotte || 0));
    const betegSzab = Math.min(beteg, maradt);
    const o = Number(a.napi_ora) || 8;
    const r = (x: number) => Math.round(x);   // a munkaórák egész órára kerekítve
    return { munkanapok: naptar.munkanapok, ledolg, ledolgOra: r(ledolg * o), szab, szabOra: r(szab * o), betegSzab, betegOra: r(betegSzab * o),
      tappenz: beteg - betegSzab, fizNelk, fizNelkOra: r(fizNelk * o), nincs };
  }

  /*  SZERKESZTÉSI ZÁR (components/szerk-zar) a havi jelenlétre: kulcsa alkalmazott:év-hó (a kiszolgáló
   *  jelenletKulcs-a), mert a jelenlétnek az első mentés előtt nincs azonosítója. A sorszám a késve
   *  érkező foglalást dobja el, ha a szerkesztőt közben bezárták. */
  zarJel: SzerkZar | null = null;
  private zarJelSorsz = 0;
  private async jelZarFoglal(e: any) {
    const s = ++this.zarJelSorsz;
    this.zarJel?.felenged(); this.zarJel = null;
    const kulcs = `${e.alkalmazott_id}:${Number(this.aktiv.ev)}-${Number(this.aktiv.ho)}`;
    const z = await this.szerkZar.foglal('ber', 'ber_jelenlet', kulcs, {
      ujratolt: async () => { if (this.jelSzerk?.alkalmazott_id === e.alkalmazott_id) await this.jelBetolt(e); },
    });
    if (s !== this.zarJelSorsz) { z?.felenged(); return; }
    this.zarJel = z;
  }
  jelZarEngedi() { this.zarJelSorsz++; this.zarJel?.felenged(); this.zarJel = null; }
  ngOnDestroy() { this.jelZarEngedi(); }

  async jelNyit(e: any) {
    await this.jelBetolt(e);
    this.jelModal.present();
    this.jelZarFoglal(e);
  }
  /** A jelenlét (és a napi nézet) betöltése a szerkesztőbe – nyitáskor és a zár újratöltésekor. */
  private async jelBetolt(e: any) {
    const lista: any[] = await this.ber.get('/jelenlet/' + this.aktiv.ugyfelId + this.ber.evhoq());
    const meglevo = lista.find((x) => x.alkalmazott_id === e.alkalmazott_id);
    this.jelSzerk = meglevo
      ? { ...meglevo }
      : { ugyfel_id: this.aktiv.ugyfelId, alkalmazott_id: e.alkalmazott_id, ev: this.aktiv.ev, ho: this.aktiv.ho, ledolgozott_orak: 0, ledolgozott_napok: 0,
        szabadsag_orak: 0, betegszabadsag_orak: 0, tappenz_napok: 0, fizetett_tavollet: 0, fizetes_nelkuli_orak: 0, tullora: 0, ejszakai: 0, vasarnapi: 0, muszakpotlek: 0 };
    this.jelSzerk.alkalmazott_nev = e.alkalmazott_nev;
    this.jelKep = null; this.jelHetek = []; this.jelNapok = {}; this.ecset = 1;
    try {
      this.jelKep = await this.ber.sulinformApi.get(`/jelenlet/${this.aktiv.ugyfelId}${this.ber.evhoq({ alkalmazott_id: e.alkalmazott_id })}`);
      this.jelHetekSzamol();
      const a = this.jelAlk;
      this.jelNapok = { ...(a?.napok || {}) };
      // Napi nézet: SULINFORM-os alkalmazottnál, vagy ha már napra bontva rögzítettek; különben a régi összesítő.
      this.jelMod = a && (a.kotott || Object.keys(a.napok || {}).length || !meglevo) ? 'napok' : 'osszesito';
    } catch { this.jelMod = 'osszesito'; }
  }

  async jelMent() {
    if (this.zarJel && !this.zarJel.irhato) return;
    const potlek = { tullora: this.jelSzerk.tullora, ejszakai: this.jelSzerk.ejszakai, vasarnapi: this.jelSzerk.vasarnapi, muszakpotlek: this.jelSzerk.muszakpotlek };
    try {
      if (this.jelMod === 'napok' && this.jelAlk) {
        const r: any = await this.ber.sulinformApi.put(`/jelenlet/${this.aktiv.ugyfelId}/${this.jelSzerk.alkalmazott_id}/napok`,
          { ev: this.aktiv.ev, ho: this.aktiv.ho, napok: this.jelNapok, potlek });
        await this.jelModal.dismiss(); await this.szamol();
        this.ok(`Jelenlét mentve${r?.visszairva ? `, ${r.visszairva} nap visszaírva a SULINFORM-ba` : ''}; újraszámolva.`);
      } else {
        this.jelSzerk.ev = this.aktiv.ev; this.jelSzerk.ho = this.aktiv.ho; this.jelSzerk.forras = 'BER';
        await this.ber.post('/jelenlet', this.jelSzerk);
        await this.jelModal.dismiss(); await this.szamol(); this.ok('Jelenlét mentve, újraszámolva.');
      }
    } catch (err: any) { this.hiba(err?.error?.error || 'Nem sikerült menteni a jelenlétet.'); }
  }

  /** A hónap jelenlétének átvétele a SULINFORM-ból minden összekötött alkalmazottra. */
  async sulinformAtvesz() {
    const a = await this.alert.create({
      header: 'Jelenlét átvétele',
      message: `${honapNev(this.aktiv.ho)} ${this.aktiv.ev}: a SULINFORM-hoz kötött alkalmazottak havi jelenléte (ledolgozott idő, szabadság, betegszabadság, táppénz, fizetés nélküli) felülíródik a SULINFORM napjaiból. A pótlék-órák megmaradnak.`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Átvétel', role: 'confirm' }],
    });
    await a.present();
    if ((await a.onDidDismiss()).role !== 'confirm') return;
    try {
      const r: any = await this.ber.sulinformApi.post(`/jelenlet/${this.aktiv.ugyfelId}/atvesz`, { ev: this.aktiv.ev, ho: this.aktiv.ho });
      await this.szamol();
      this.ok(`${r?.atveve || 0} alkalmazott jelenléte átvéve a SULINFORM-ból.`);
    } catch (err: any) { this.hiba(err?.error?.error || 'Az átvétel nem sikerült.'); }
  }

  /*  UTAZÁSI KÖLTSÉGTÉRÍTÉS ÉS KOMPENZÁCIÓ ÁTVÉTELE A SULINFORM-BÓL (backend/ber-sulinform.js).
   *
   *  A munkába járás km-térítése és a jóváhagyott kompenzáció (bérlet, óra alapú, egyéb) a
   *  SULINFORM-ban keletkezik. Az átvétel eseti tételeket ír a hónapba, jogcímenként – a
   *  km-térítés adómentes és adóköteles része külön, mert máshogy adózik, és a költségtérítés
   *  a Vht. 74. § i) alapján a letiltás alapjába sem számít bele. */
  koltseg: any = null;
  koltsegTolt = false;
  koltsegKer = { utazas: true, kompenzacio: true };
  koltsegKijelolt: Record<string, boolean> = {};

  async koltsegNyit() {
    this.koltseg = null;
    this.koltsegKijelolt = {};
    await this.koltsegModal.present();
    await this.koltsegBetolt();
  }
  async koltsegBetolt() {
    this.koltsegTolt = true;
    try {
      this.koltseg = await this.ber.sulinformApi.get(`/koltseg/${this.aktiv.ugyfelId}${this.ber.evhoq()}`);
      //  Alapból mindenkit átveszünk, akinél van mit.
      for (const s of this.koltseg.sorok || []) this.koltsegKijelolt[s.alkalmazott_id] = this.koltsegVanMit(s);
    } catch (e: any) {
      this.koltseg = null;
      this.hiba(e?.error?.error || 'Nem sikerült betölteni az átvehető tételeket.');
    }
    this.koltsegTolt = false;
  }
  koltsegVanMit(s: any): boolean {
    return (s.utazas?.osszeg || 0) > 0 || (s.kompenzacio?.berlet || 0) > 0 || (s.kompenzacio?.ora || 0) > 0 || (s.kompenzacio?.egyeb || 0) > 0;
  }
  koltsegSorOsszeg(s: any): number {
    let o = 0;
    if (this.koltsegKer.utazas) o += s.utazas?.osszeg || 0;
    if (this.koltsegKer.kompenzacio) o += (s.kompenzacio?.berlet || 0) + (s.kompenzacio?.ora || 0) + (s.kompenzacio?.egyeb || 0);
    return o;
  }
  get koltsegValasztott(): any[] {
    return (this.koltseg?.sorok || []).filter((s: any) => this.koltsegKijelolt[s.alkalmazott_id] && this.koltsegSorOsszeg(s) > 0);
  }
  get koltsegVegosszeg(): number {
    return this.koltsegValasztott.reduce((o, s) => o + this.koltsegSorOsszeg(s), 0);
  }
  async koltsegAtvesz() {
    const ids = this.koltsegValasztott.map((s) => s.alkalmazott_id);
    if (!ids.length) return;
    try {
      const r: any = await this.ber.sulinformApi.post(`/koltseg/${this.aktiv.ugyfelId}/atvesz${this.ber.evhoq()}`,
        { ev: this.aktiv.ev, ho: this.aktiv.ho, alkalmazott_ids: ids, utazas: this.koltsegKer.utazas, kompenzacio: this.koltsegKer.kompenzacio });
      await this.koltsegBetolt();
      await this.szamol();
      const mar = (r?.szamfejtettek || []).length;
      this.ok(`${r?.tetel || 0} tétel átvéve (${Number(r?.osszeg || 0).toLocaleString('hu-HU')} Ft).`
        + (mar ? ` ${mar} alkalmazott hónapja már mentve volt – a mentést újra kell futtatni.` : ''));
    } catch (e: any) { this.hiba(e?.error?.error || 'Az átvétel nem sikerült.'); }
  }

  /*  EGYÉB (ESETI) TÉTELEK egy alkalmazott hónapjára – prémium, jutalom, levonás … a jogcím-törzsből
   *  (backend/ber-torzs.js). Az állandó és a nyugdíjpénztári tételek az alkalmazottnál állíthatók. */
  egyebAlk: any = null;
  egyebLista: any[] = [];
  egyebJogcimek: any[] = [];
  egyebUj: any = { jogcim_id: null, osszeg: null, megjegyzes: '' };
  async egyebNyit(e: any) {
    this.egyebAlk = e;
    if (!this.egyebJogcimek.length) {
      this.egyebJogcimek = (await this.ber.torzsApi.get<any[]>('/jogcimek/' + this.aktiv.intezmeny).catch(() => [])).filter((j) => !j.rendszer && j.aktiv);
    }
    this.egyebUj = { jogcim_id: this.egyebJogcimek[0]?.id || null, osszeg: null, megjegyzes: '' };
    await this.egyebBetolt();
    this.egyebModal.present();
  }
  private async egyebBetolt() {
    this.egyebLista = await this.ber.torzsApi.get<any[]>(`/egyeb/${this.aktiv.ugyfelId}${this.ber.evhoq({ alkalmazott_id: this.egyebAlk.alkalmazott_id })}`).catch(() => []);
  }
  async egyebHozzaad() {
    try {
      await this.ber.torzsApi.post('/egyeb', { ...this.egyebUj, ugyfel_id: this.aktiv.ugyfelId, alkalmazott_id: this.egyebAlk.alkalmazott_id, ev: this.aktiv.ev, ho: this.aktiv.ho });
      this.egyebUj = { ...this.egyebUj, osszeg: null, megjegyzes: '' };
      await this.egyebBetolt(); await this.szamol();
    } catch (err: any) { this.hiba(err?.error?.error || 'Nem sikerült menteni a tételt.'); }
  }
  async egyebTorol(t: any) {
    try { await this.ber.torzsApi.del('/egyeb/' + t.id); await this.egyebBetolt(); await this.szamol(); }
    catch (err: any) { this.hiba(err?.error?.error || 'Nem sikerült törölni.'); }
  }
  get egyebJovedelem(): number { return this.egyebLista.filter((t) => t.tipus !== 'levonas').reduce((a, t) => a + Number(t.osszeg || 0), 0); }
  get egyebLevonas(): number { return this.egyebLista.filter((t) => t.tipus === 'levonas').reduce((a, t) => a + Number(t.osszeg || 0), 0); }

  // .beo import
  async beoImport(ev: any) {
    const f = ev.target.files?.[0];
    if (!f) return;
    const fd = new FormData(); fd.append('file', f);
    try {
      const r: any = await (this.ber as any).post('/jelenlet/import-beo/' + this.aktiv.ugyfelId, fd);
      await this.szamol();
      this.ok(`${r?.frissitett || 0} jelenlét importálva${r?.parositlan?.length ? ', párosítatlan: ' + r.parositlan.join(', ') : ''}.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Import hiba.'); }
    ev.target.value = '';
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1800, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2800, color: 'danger' })).present(); }
}
